module.exports = __webpack_public_path__ + "media/images/sales/set/bg-mv-set-baf44f29456fa9bd5598723cad936651.svg";